import React from 'react';
import { useOidcAuthentication } from '../../auth';
import { useChatbot } from './use-chatbot';
import { useExcludeChatbotFromPath } from './useExcludeChatbotFromPath';

interface OidcChatbotProps {
    excludedPaths?: string[];
    context: Record<string, unknown>;
    userId?: string;
    mercuryApiKey: string;
    mercuryCssUrl: string;
    jestWorkerId?: string;
}

export const ChatbotOidc: React.FC<OidcChatbotProps> = ({
    excludedPaths,
    context,
    userId,
    mercuryApiKey,
    mercuryCssUrl,
    jestWorkerId,
}) => {
    const auth = useOidcAuthentication();
    useExcludeChatbotFromPath(excludedPaths);
    const customerID = auth?.token || '';
    useChatbot(customerID, context, userId, mercuryApiKey, jestWorkerId);

    return (
        <div data-testid="mercury-widget-snippet">
            <link rel="stylesheet" type="text/css" href={mercuryCssUrl} />
        </div>
    );
};
